<template>
    <modal :id="utils.randomId({prefix: 'settings'})"
           size="lg"
           :show="true"
           v-if="team"
           @close="close()">
        <template #title>
            Team Settings
        </template>

        <div class="form-group">
            <label for="team-name">Team Name</label>
            <input type="text" id="team-name" class="form-control form-control-lg"
                   v-model="team.name"
                   @keyup.prevent="updateDebounced">
        </div>

        <h5>Students</h5>

        <div class="form-group" v-for="member in team.members" :key="member.id">

            <editable-text v-model="member.first_name" @change="update()"/>

<!--            <input type="text" :id="`member-${member.id}-name`" class="form-control form-control-lg"-->
<!--                   v-model="member.first_name"-->
<!--                   @keyup.prevent="updateDebounced">-->
        </div>


        <template #footer>
            <button type="button"
                    class="btn btn-warning"
                    @click="close()">Close</button>
        </template>

    </modal>
</template>

<script>
import API from "@/API";
import utils from "@/mixins/utils";
import Modal from "@/Components/Common/Modal";
import StateButton from "@/Components/Common/StateButton";
import EditableText from "@/Components/Common/EditableText";

export default {
    name: "TeamSettingsModal",
    components: {EditableText, Modal, StateButton},
    props: ['team'],
    emits: ['close'],
    mixins: [utils],

    data(){
        return {
            updateDebounced: _.debounce((...args) => this.update(), 500),
        }
    },


    computed: {

    },

    methods: {


        async update(){
            await API.teams.updateBulk(this.team);
            console.log({team: this.team});
        },

        close(){
            this.$emit('close');
        }

    },


    mounted() {

    }

}
</script>

<style scoped>

</style>
